// GENERATED by `pnpm sync:contracts` from ../sawakart-scrapper-backend/src/infrastructure/websocket/socket-events.ts. Do not edit here: change the backend and re-sync.

/**
 * The WebSocket contract between this backend and the website (Socket.IO).
 * The frontend copies this file with `pnpm sync:contracts`; change both sides together.
 */
export const SOCKET_NAMESPACE = '/events';

/** `delayed`: the attempt failed and the job waits to be retried (backoff). */
export type JobState = 'waiting' | 'active' | 'progress' | 'delayed' | 'completed' | 'failed';

export interface JobProgress {
  step: number;
  of: number;
  message?: string;
}

export interface JobUpdate {
  queue: string;
  jobId: string;
  state: JobState;
  progress?: JobProgress;
  failedReason?: string;
  /** ISO time the server saw the change. */
  at: string;
}

/** Where one fetched page stands. `retrying`: blocked everywhere, back in the queue after a wait. */
export type FetchPageStatus = 'queued' | 'fetching' | 'retrying' | 'ok' | 'gone' | 'failed';

export interface FetchPageUpdate {
  runId: string;
  pageId: string;
  kind: 'product' | 'listing' | 'offers';
  url: string;
  asin?: string;
  status: FetchPageStatus;
  title?: string;
  price?: number;
  variantCount?: number;
  /** Results on a listing page. */
  resultCount?: number;
  engine?: 'http' | 'browser';
  proxy?: string;
  attempts: number;
  blockedAttempts: number;
  durationMs?: number;
  error?: string;
  /** ISO time of the last change. */
  at: string;
}

export type ProxyState = 'ready' | 'busy' | 'cooling';

/** One proxy as the website shows it: by its label (the port), never its login. */
export interface ProxyHealth {
  id: string;
  label: string;
  state: ProxyState;
  /** ISO time the cool-down ends. */
  coolUntil?: string;
  requests: number;
  ok: number;
  blocked: number;
  errors: number;
  avgLatencyMs?: number;
  lastUsedAt?: string;
}

/** Where one line of an import stands (see the intake module). */
export type ImportItemStatus =
  | 'queued'
  | 'fetching'
  | 'fetching_variants'
  | 'fetching_offers'
  | 'weighing'
  | 'ready'
  | 'rejected'
  | 'duplicate'
  | 'failed'
  | 'expanded';

/** What a duplicate duplicates: a published store product, or a product v2 already has. */
export interface DuplicateRef {
  asin: string;
  source: 'store' | 'v2';
  handle?: string;
  productId?: string;
  sameImport?: boolean;
}

export interface ImportItemUpdate {
  importId: string;
  itemId: string;
  kind: 'product' | 'listing';
  input: string;
  /** The listing item this product came from. */
  parentItemId?: string;
  asin?: string;
  title?: string;
  status: ImportItemStatus;
  reason?: string;
  duplicateOf?: DuplicateRef;
  productId?: string;
  /** ISO time of the last change. */
  at: string;
}

export interface ServerToClientEvents {
  'job:update': (update: JobUpdate) => void;
  'fetch:page': (update: FetchPageUpdate) => void;
  'proxy:health': (proxies: ProxyHealth[]) => void;
  'import:item': (update: ImportItemUpdate) => void;
}

/** The website only listens for now: no event may be sent to the server. */
export type ClientToServerEvents = Record<string, never>;
